// The old Firestore "guest -> real user" migration has no equivalent in
// experience-backend yet (anonymous users don't carry any migratable data
// beyond their uid, which is already what everything keys on). Honest no-op
// so callers don't crash.
export const migrateGuestToNewUser = async (_userId) => {
  console.warn(
    "migrateGuestToNewUser: not supported by experience-backend yet."
  );
};
